import React from 'react'
import {useEffect as uEffect, useState as uState} from 'react';

export default function invoice() {
    const [data, setData] = uState([]);
    uEffect(() => {
        fetch("http://localhost:8000/order/orderPayment", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
        }).then((response) => response.json()).then((data) => setData(data));
    }, []);
    const user = data.filter(product => product.hasOwnProperty('PaymentStatus'));
    const order = data.filter(product => product.hasOwnProperty('OrderId'));    

    const handlePrint = () => {
        window.print()
    }

    var randomNumber = Math.floor(Math.random() * 90000) + 10000;
    let today=new Date().toLocaleString()
  return (
      <>
          {
              user.map((item, index) => {
                  return (
                      <div className="card-header" key={index}>
                          <div class="container">
                              <div class="row">
                                  <div class="col-lg-12">
                                      <div class="card">
                                          <div class="card-body">
                                              <div class="invoice-title">
                                                  <h4 class="float-end font-size-15">Invoice {randomNumber}<span class="badge bg-success font-size-12 ms-2">{item.PaymentStatus}</span></h4>
                                                  <div class="mb-4">
                                                      <h2 class="mb-1 text-muted">MediCart.com</h2>
                                                  </div>
                                                  <div class="text-muted">
                                                      <p class="mb-1">Balgarh Road, Sonipat 131001</p>
                                                      <p class="mb-1"><i class="uil uil-envelope-alt me-1"></i> medicart@gmail.com</p>
                                                      <p><i class="uil uil-phone me-1"></i> +91-9671810274</p>
                                                  </div>
                                              </div>

                                              <hr class="my-4" />

                                              <div class="row">
                                                  <div class="col-sm-6">
                                                      <div class="text-muted">
                                                          <h5 class="font-size-16 mb-3">Billed To:</h5>
                                                          <h5 class="font-size-15 mb-2">{item.UserId}</h5>
                                                          <p class="mb-1">{item.UserEmail}</p>
                                                          {/* <p class="mb-1">{item.UserAddress}</p>
                                          <p>{item.UserMobile}</p> */}
                                                      </div>
                                                  </div>

                                                  <div class="col-sm-6">
                                                      <div class="text-muted text-sm-end">
                                                          <div>
                                                              <h5 class="font-size-15 mb-1">Invoice No:</h5>
                                                              <p>#{randomNumber}</p>
                                                          </div>
                                                          <div class="mt-4">
                                                              <h5 class="font-size-15 mb-1">Invoice Date:</h5>
                                                              <p>{today}</p>
                                                          </div>
                                                      </div>
                                                  </div>

                                              </div>


                                              <div class="py-2">
                                                  {
                                                      
                                                      order.map((itm,indx) => {
                                                          return (
                                                              <div key={indx}>
                                                                  <h5 class="font-size-15">Order Summary</h5>      
                                                                  <div class="mt-4">
                                                                      <h5 class="font-size-15 mb-1">Order No:</h5>
                                                                      <p>{itm.OrderId}</p>
                                                                  </div>
                                                                  <div class="table-responsive">
                                                                      <table class="table align-middle table-nowrap table-centered mb-0">
                                                                          <thead>
                                                                              <tr>
                                                                                  <th style={{ width: '70px' }}>No.</th>
                                                                                  <th>Item Title</th>
                                                                                  <th>Product Amount</th>
                                                                                  <th>Product Quantity</th>
                                                                                  <th class="text-end" style={{ width: '120px' }}>Total</th>
                                                                              </tr>
                                                                          </thead>
                                                                          <tbody>
                                                                              <tr>
                                                                                  <th scope="row">{indx+1}</th>
                                                                                  <td>
                                                                                      <div>
                                                                                          <h5 class="text-truncate font-size-14 mb-1">{itm.ProductTitle}</h5>
                                                                                          <h6 class="text-truncate font-size-14 mb-1">{itm.ProductType}</h6>
                                                                                      </div>
                                                                                  </td>
                                                                                  <td>₹{itm.OriginalAmount}</td>
                                                                                  <td>{itm.ProductQuantity}mg</td>  
                                                                                  <td class="text-end">₹{item.TotalAmount}</td>                                                                                  
                                                                              </tr>

                                                                              <tr>
                                                                                  <th scope="row" colspan="4" class="text-end">Sub Total</th>
                                                                                  <td class="text-end">₹{item.TotalAmount}</td>
                                                                              </tr>

                                                                              <tr>
                                                                                  <th scope="row" colspan="4" class="border-0 text-end">
                                                                                      Shipping Charge :</th>
                                                                                  <td class="border-0 text-end">₹{parseInt(itm.OriginalAmount)+3}</td>
                                                                              </tr>

                                                                              <tr>
                                                                                  <th scope="row" colspan="4" class="border-0 text-end">
                                                                                      SGST</th>
                                                                                  <td class="border-0 text-end">₹{parseInt(itm.OriginalAmount) + 2}</td>
                                                                              </tr>
                                                                              <tr>
                                                                                  <th scope="row" colspan="4" class="border-0 text-end">
                                                                                      CGST</th>
                                                                                  <td class="border-0 text-end">₹{parseInt(itm.OriginalAmount) + 1}</td>
                                                                              </tr>
                                                                              <tr>
                                                                                  <th scope="row" colspan="4" class="border-0 text-end">
                                                                                      Discount :</th>
                                                                                  <td class="border-0 text-end">- ₹{(parseInt(item.TotalAmount)+6)}</td>
                                                                              </tr>                                                                              

                                                                              <tr>
                                                                                  <th scope="row" colspan="4" class="border-0 text-end">Total</th>
                                                                                  <td class="border-0 text-end"><h4 class="m-0 fw-semibold">₹{item.TotalAmount}</h4></td>
                                                                              </tr>

                                                                          </tbody>
                                                                      </table>
                                                                  </div>                                                                  
                                                            </div>
                                                        )
                                                    })

                                                      }
                                                  
                                              </div>
                                              <div class="d-print-none mt-4">
                                                  <div class="float-end">
                                                      <button onClick={handlePrint} class="btn btn-success me-1">Print</button>
                                                  </div>
                                              </div>                                              
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  )
              })
          }
          
          
      </>
  )
}
